import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CHECKBOXES_TO_TIMING_TYPE = new Map([
  [JSON.stringify({ always: false, oneRemaining: false, everyFive: false }), 0],
  [JSON.stringify({ always: true, oneRemaining: false, everyFive: false }), 1],
  [JSON.stringify({ always: false, oneRemaining: false, everyFive: true }), 5],
  [JSON.stringify({ always: false, oneRemaining: true, everyFive: false }), 10],
  [JSON.stringify({ always: false, oneRemaining: true, everyFive: true }), 15],
]);

const TIMING_TYPE_TO_CHECKBOXES = {
  0: { always: false, oneRemaining: false, everyFive: false },
  1: { always: true, oneRemaining: false, everyFive: false },
  5: { always: false, oneRemaining: false, everyFive: true },
  10: { always: false, oneRemaining: true, everyFive: false },
  15: { always: false, oneRemaining: true, everyFive: true },
};

// オブジェクトから数値を取得
const getTiming = (state) => {
  return CHECKBOXES_TO_TIMING_TYPE.get(JSON.stringify(state));
};

// 数値からオブジェクトを取得
const getCheckboxState = (timing) => {
  return TIMING_TYPE_TO_CHECKBOXES[timing] || null;
};

const ShareTiming = ({ snsAccount, circle, isReactNativeApp }) => {
  const [checkboxes, setCheckboxes] = useState({
    always: false,
    oneRemaining: false,
    everyFive: false,
  });

  useEffect(() => {
    axios.get(`/api/sns_share_options/${snsAccount.id}`).then((res) => {
      const shareTimingSetting = res.data.timing_type;
      const newState = getCheckboxState(shareTimingSetting);
      if (newState === null) {
        return;
      }
      setCheckboxes(newState);
    });
  }, []);

  const decisionNewTiming = (name, checked) => {
    const newTiming = { ...checkboxes };

    if (name === 'always' && checked) {
      newTiming.always = checked;
      newTiming.oneRemaining = false;
      newTiming.everyFive = false;
    } else if (name !== 'always' && checked) {
      newTiming.always = false;
      newTiming[name] = checked;
    } else {
      newTiming[name] = checked;
    }

    return newTiming;
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;

    const newTiming = decisionNewTiming(name, checked);
    const newTimingType = getTiming(newTiming);

    if (newTimingType === null) {
      return;
    }

    axios
      .patch(`/api/sns_share_options/${snsAccount.id}`, {
        timing_type: newTimingType,
      })
      .then((res) => {
        setCheckboxes(newTiming);
      });
  };

  const deleteSnsAccount = () => {
    if (confirm('SNS連携を解除しますか？再設定には再度連携が必要です。')) {
      const circleId = snsAccount.circle_id;
      const snsAccountId = snsAccount.id;
      const url = `/api/circle/${circleId}/sns_accounts/${snsAccountId}`;

      axios
        .delete(url)
        .then((res) => {
          if (res.status === 200) {
            window.location.href = `/circle/${circleId}/sns_accounts`;
          }
        })
        .catch((error) => {
          alert('エラーが発生しました。もう一度お試しください。');
        });
    }
  };

  return (
    <div className="container col-md-8 col-lg-6">
      <h2 className="text-fz-18px text-fw-bold mt-5">シェアタイミング設定</h2>
      <p className="text-black-666">
        このサークルのイベントに申し込みがあると、設定したタイミングで自動的にシェアされます
      </p>
      <div>
        <div>
          <input
            type="checkbox"
            name="always"
            id="always"
            value="1"
            className="mr-1"
            checked={checkboxes.always}
            onChange={handleChange}
          />
          <label className="mb-0 text-black-666" htmlFor="always">
            すべての参加申し込みをシェアする
          </label>
        </div>
        <div className="d-flex align-items-center justify-content-center my-3">
          <div className="flex-grow-1 border-top"></div>
          <span className="mx-2 px-2 text-black-666 text-fz-10px">または</span>
          <div className="flex-grow-1 border-top"></div>
        </div>
        <div className="d-flex align-items-start">
          <input
            type="checkbox"
            name="oneRemaining"
            id="oneRemaining"
            value="2"
            className="mr-1 mt-2"
            checked={checkboxes.oneRemaining}
            onChange={handleChange}
          />
          <label htmlFor="oneRemaining">
            <p className="mb-0 text-black-666">
              あと一人で満席の時にシェアする <br />
              （空席が発生したときを含む）
            </p>
          </label>
        </div>
        <div>
          <input
            type="checkbox"
            name="everyFive"
            id="everyFive"
            value="3"
            className="mr-1"
            checked={checkboxes.everyFive}
            onChange={handleChange}
          />
          <label className="text-black-666" htmlFor="everyFive">
            参加者が5人増えるごとにシェアする
          </label>
        </div>
      </div>
      <div className="d-flex text-align-center justify-content-center mt-5">
        <p
          className="text-fz-12px"
          style={{ cursor: 'pointer', color: '#48A3E9' }}
          onClick={deleteSnsAccount}
        >
          SNS連携を解除する
        </p>
      </div>
    </div>
  );
};

export default ShareTiming;
